<template>
    <DataTable
        ref="productsTable"
        :value="products"
        v-if="products"
        selectionMode="single"
        @row-click="
            (event: DataTableRowClickEvent) => {
                const rowLink = `product-link-${event.data.identity}`;
                productsTable.$el.querySelector(`#${rowLink}`)?.click();
            }
        "
    >
        <template #header>
            <div style="display: flex; justify-content: space-between">
                <h2>Products & Services</h2>
                <Button
                    v-if="isEditing"
                    class="p-button-secondary"
                    icon="pi pi-plus"
                    label="Add product or service"
                    severity="secondary"
                    size="small"
                    text
                    @click="openNewProduct()"
                />
            </div>
        </template>

        <template #empty>
            <div>No products or services</div>
        </template>
        <Column field="name" header="Name" class="name-col">
            <template #body="{ data, field }">
                <RouterLink
                    :id="`product-link-${data.identity}`"
                    class="product-link"
                    :to="{
                        name: 'productPage',
                        params: {
                            orgName: route.params.orgName,
                            stekName: route.params.stekName,
                            productId: data.identity,
                        },
                    }"
                >
                    <div>
                        {{ data[field] }}
                    </div>
                </RouterLink>
            </template>
        </Column>
        <Column field="short_description" header="Description">
            <template #body="slotProps">
                <template v-if="slotProps.data.short_description">
                    {{ slotProps.data.short_description }}
                </template>
                <span
                    v-else
                    v-tooltip.top="'A description is not (yet) available'"
                >
                    ...
                </span>
            </template>
        </Column>
    </DataTable>
</template>

<script setup lang="ts">
import type { DataTableRowClickEvent } from "primevue/datatable";
import type { ProductInTree } from "@/stores/products-store";
import { useRoute } from "vue-router";
import { useNewProductDialog } from "@/composables/new-product-dialog";
import { ref } from "vue";

defineProps<{
    isEditing: boolean;
    products: ProductInTree[];
}>();
const route = useRoute();
const productsTable = ref();
const { open: openNewProduct } = useNewProductDialog();
</script>

<style scoped lang="scss">
.product-link {
    text-decoration: none;
}

:deep(.p-datatable-thead) > tr > th,
:deep(.p-datatable-tbody) > tr > td {
    &.buttons-col {
        min-width: 50px;
        text-align: right;
    }
    &.name-col {
        width: 30rem;
    }
}
:deep(.p-datatable-tbody) > tr > td.buttons-col {
    padding-top: 0;
    padding-bottom: 0;
}
</style>
